import { combineReducers } from '@reduxjs/toolkit';
import domainFilterReducer from './slices/DomainFilterSlice';

// SAMPLE
const previewReducer = combineReducers({
  domainFilter: domainFilterReducer,
});

const projectPreviewReducer = (state: any, action: any) => {
  if (action.type === 'RESET_PROJECT') {
    state = undefined;
  }

  return previewReducer(state, action);
};

export type ProjectPreviewState = ReturnType<typeof previewReducer>;
export default projectPreviewReducer;
